import { render, staticRenderFns } from "./DialogExClienti.vue?vue&type=template&id=3fd56e9c&"
import script from "./DialogExClienti.vue?vue&type=script&lang=js&"
export * from "./DialogExClienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports